import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LogoutPopupComponent } from '../../../../../core/libraries/popup/components/logout-popup/logout-popup.component';
import { StorageService } from '../../../../../core/services/storage/storage.service';

@Component({
    selector: 'app-profile-dropdown',
    standalone: false,
    templateUrl: './profile-dropdown.component.html',
    styleUrl: './profile-dropdown.component.scss',
})
export class ProfileDropdownComponent {
    protected isOpen = false;
    protected loginUser? = this.storageService.getLoginUser();

    constructor(
        private storageService: StorageService,
        private router: Router,
        private dialog: MatDialog,
    ) {}

    toggleDropdown(): void {
        this.isOpen = !this.isOpen;
    }

    signOut(): void {
        const popupConfig = LogoutPopupComponent.getDialogConfig();
        const dialogRef = this.dialog.open(LogoutPopupComponent, popupConfig);
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.router.navigate(['logout']);
            }
        });
    }
}
